import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PROVIDERS } from '../../../../angularjs-app/app/common/providers.constant';

@Component({
  selector: 'mandae-integration-setup-select-provider',
  templateUrl: './integration-setup-select-provider.component.html',
  styleUrls: ['./integration-setup-select-provider.component.scss', '../integration-setup-dialog.shared.scss']
})
export class IntegrationSetupSelectProviderComponent implements OnInit {

  @Output() providerSelect = new EventEmitter();

  public erpProviders = PROVIDERS.filter(provider => provider.type === 'erp');
  public platformProviders = PROVIDERS.filter(provider => provider.type === 'platform');

  public apiProviders = PROVIDERS.filter(provider => provider.slug === 'api');
  public manualProvider = PROVIDERS.filter(provider => provider.slug === 'webapp').shift();
  public sheetProvider = PROVIDERS.filter(provider => provider.slug === 'planilha').shift();

  constructor() { }

  ngOnInit() {
  }

  select(provider) {
    this.providerSelect.emit(provider);
  }

}
